export default "__VITE_ASSET__BRXDsQ3w__"